const cards = [
  {
    tag: '国产热播',
    title: '古装权谋剧持续霸榜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20imperial%20palace%20interior%20with%20warm%20golden%20candlelight%2C%20ornate%20wooden%20furniture%2C%20flowing%20silk%20curtains%2C%20historical%20drama%20aesthetic%2C%20rich%20red%20and%20gold%20color%20palette%2C%20cinematic%20lighting%2C%20elegant%20composition&width=600&height=400&seq=card-01-palace&orientation=landscape',
  },
  {
    tag: '韩剧精选',
    title: '甜宠爱情剧全集上线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20Korean%20drama%20scene%20aesthetic%2C%20cherry%20blossom%20park%20with%20warm%20spring%20sunlight%2C%20gentle%20pastel%20color%20tones%2C%20couple%20silhouette%20on%20bench%2C%20dreamy%20bokeh%20background%2C%20emotional%20cinematic%20mood%2C%20soft%20focus%20photography&width=600&height=400&seq=card-02-kdrama&orientation=landscape',
  },
  {
    tag: '悬疑专区',
    title: '烧脑推理剧高分推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dimly%20lit%20detective%20office%20with%20evidence%20board%20and%20investigation%20photos%2C%20desk%20lamp%20creating%20dramatic%20shadows%2C%20noir%20atmosphere%2C%20warm%20tungsten%20light%2C%20mysterious%20mood%2C%20cinematic%20composition%2C%20film%20noir%20aesthetic&width=600&height=400&seq=card-03-mystery&orientation=landscape',
  },
  {
    tag: '电影大全',
    title: '院线大片高清上线',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20movie%20theater%20interior%20with%20red%20velvet%20curtains%20and%20golden%20accents%2C%20large%20projection%20screen%2C%20vintage%20cinema%20chairs%2C%20warm%20ambient%20lighting%2C%20theatrical%20atmosphere%2C%20elegant%20old%20Hollywood%20style%2C%20rich%20textures&width=600&height=400&seq=card-04-movies&orientation=landscape',
  },
  {
    tag: '综艺娱乐',
    title: '热门综艺最新一期',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20TV%20studio%20set%20with%20vibrant%20stage%20lighting%2C%20entertainment%20show%20atmosphere%2C%20modern%20broadcast%20equipment%2C%20energetic%20vibe%2C%20warm%20spotlight%20effects%2C%20dynamic%20composition%2C%20professional%20television%20production&width=600&height=400&seq=card-05-variety&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            分类精选
          </h2>
          <p className="text-sm text-foreground-500">按类型发现，总有一部适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#index"
              className="group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={`黄瓜影院${card.tag} - ${card.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-2">
                  {card.tag}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-accent-600 transition-colors">
                  {card.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}